import { render, staticRenderFns } from "./PrepProcessDetail.vue?vue&type=template&id=122b553e"
import script from "./PrepProcessDetail.vue?vue&type=script&lang=js"
export * from "./PrepProcessDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports